"use client";

import { FallbackImageAsset } from "@/components/fallback-image-asset";

import { VinylIcon } from "./vinyl-spinner";

function PersonIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="60" cy="44" r="20" fill="currentColor" className="text-foreground/10" />
      <ellipse cx="60" cy="96" rx="34" ry="22" fill="currentColor" className="text-foreground/10" />
    </svg>
  );
}

function CompanyIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect
        x="28"
        y="29"
        width="64"
        height="62"
        stroke="currentColor"
        strokeWidth="5"
        className="text-foreground/10"
      />
      <path
        d="M40 46h40M40 60h40M40 74h27"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        className="text-foreground/10"
      />
    </svg>
  );
}

type FallbackVariant = "vinyl" | "person" | "company";

function fallbackIconForVariant(fallback: FallbackVariant) {
  if (fallback === "person") return PersonIcon;
  if (fallback === "company") return CompanyIcon;
  return VinylIcon;
}

interface FallbackImageProps {
  src: string | null | undefined;
  alt: string;
  fallback?: FallbackVariant;
  className?: string;
  priority?: boolean;
  showLoadingSpinner?: boolean;
  sizes?: string;
  srcSet?: string;
  onLoad?: () => void;
  onError?: () => void;
  objectFit?: "contain" | "cover";
}

export function FallbackImage(props: FallbackImageProps) {
  const {
    src,
    alt,
    className,
    fallback = "vinyl",
    objectFit = "cover",
    onError,
    onLoad,
    priority = false,
    showLoadingSpinner = false,
    sizes,
    srcSet,
  } = props;
  const Icon = fallbackIconForVariant(fallback);
  const fallbackElement = (
    <div className="w-full h-full flex items-center justify-center">
      <Icon className="w-1/2 h-1/2" />
    </div>
  );

  return (
    <div className="w-full h-full relative">
      {!src ? (
        fallbackElement
      ) : (
        <FallbackImageAsset
          key={`${src}\u0000${srcSet ?? ""}`}
          alt={alt}
          className={className}
          fallback={fallbackElement}
          objectFit={objectFit}
          onLoad={onLoad}
          onError={onError}
          priority={priority}
          showLoadingSpinner={showLoadingSpinner}
          sizes={sizes}
          src={src}
          srcSet={srcSet}
        />
      )}
    </div>
  );
}
